/**
 * VideoHero Component
 *
 * Hero section for the Video page.
 */

import { memo } from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import { publicAsset } from '../../utils/assetUrl';

export const VideoHero = memo(function VideoHero() {
  const { t } = useTranslation();

  return (
    <div className="text-center mb-6 md:mb-8 px-2">
      <img
        src={publicAsset('logo-96.png')}
        alt="Asgard Studio"
        className="inline-block w-12 h-12 md:w-16 md:h-16 mb-3 md:mb-4"
      />
      <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-white mb-2 break-words">
        {t('video.hero.title', { defaultValue: 'AI Video Studio' })}
      </h2>
      <p className="text-xs sm:text-sm md:text-base text-white/60 max-w-xl mx-auto break-words leading-relaxed">
        {t('video.hero.description', {
          defaultValue:
            'Generate clips, animate images, create talking heads, or produce full videos',
        })}
      </p>
    </div>
  );
});
